import React, { useCallback } from 'react';
import Container from 'reactstrap/lib/Container';
import { UsurpContainer } from 'site-modules/inventory/pages/usurp/usurp-container';
import { VinPreviewCard } from 'site-modules/inventory/components/vin-preview-card/vin-preview-card';
import { VIN_PREVIEW_CREATIVE_ID } from 'site-modules/shared/components/inventory/constants/usurp-inventory-card';

export function VinPreview(props) {
  const renderAsidePageContent = useCallback(
    () => (
      <aside className="mb-3_5">
        <Container className="px-0 px-sm-0_5">
          <h2 className="text-white heading-4 px-0_5 px-md-0 mb-0_75 fw-medium">Your selection:</h2>
          <VinPreviewCard creativeId={VIN_PREVIEW_CREATIVE_ID} vin={props.vin} />
        </Container>
      </aside>
    ),
    [props.vin]
  );

  return <UsurpContainer {...props} renderAsidePageContent={renderAsidePageContent} isVinPreview />;
}
